var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThigh = function SvgThigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 127"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCCB",
    d: "M48 44c0-15.515-4.985-37.277-5.5-44-2.06 2.586-7.467 6.863-12 11-5.667 5.172-13 10.5-20 18.5C4.236 36.66 3.42 43.346.5 48-1 73.5 1.568 123.09 8 125.391c4.5 1.609 7.242 1.551 16 0 8.758-1.552 8.03-1.552 11.121-4.655s2.06-8.791 6.182-18.1S48 59.515 48 44"
  })));
};
export default SvgThigh;